import { render, staticRenderFns } from "./ReturnsDetails.vue?vue&type=template&id=6ee76ede&scoped=true&"
import script from "./ReturnsDetails.vue?vue&type=script&lang=js&"
export * from "./ReturnsDetails.vue?vue&type=script&lang=js&"
import style0 from "./ReturnsDetails.vue?vue&type=style&index=0&id=6ee76ede&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ee76ede",
  null
  
)

export default component.exports